<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Category.title') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div v-if="!categoriesLoaded" class="h-100 d-flex justify-content-center align-items-center">
          <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
        </div>
        <div v-else class="col-md-12">
          <div class="card card-form">
            <div class="card-body">
              <div class="form-section-header">{{ $t('message.Category.title') }}</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Category.name') }}</label>
                </b-col>

                <b-col sm="9">
                  {{ category.name }}
                </b-col>
              </b-row>

              <b-row v-if="0" class="my-3">
                <b-col sm="3">
                  <label class="col-form-label">Books</label>
                </b-col>

                <b-col sm="9">
                  <b-list-group>
                    <b-list-group-item  variant="primary" v-for="(book, index) in category.books" :key="index" href="#" @click.prevent="$router.push({name: 'BookView', params: {id:book.id }})">{{ book.title }}</b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>

              <div class="form-buttons">
                <button class="btn btn-primary mr-2" @click.prevent.stop="$router.push({name: 'CategoryEdit', params: {id:  category.id}})">{{ $t('message.edit') }} </button>
                <button type="submit" class="btn btn-success" @click="$router.go(-1)">{{ $t('message.return') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CATEGORY_REQUEST_BY_ID } from '@/store/actions/categories';

  export default {
    name: "CategoryView",

    data() {
      return {
        category: {
          name: null
        },
      }
    },

    mounted() {
      this.get(this.$route.params.id);
    },

    methods: {
      async get(id) {
        if (id != undefined) {
          this.$store.dispatch(CATEGORY_REQUEST_BY_ID, id).then(category => {
            this.category = category;
          }).catch(err => {
            console.error(err)
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>